import PropTypes from 'prop-types';
import { PrimaryButton, SecondaryButton } from 'jl-design-system/elements/button/Button';

import styles from './FormEditButtons.scss';

export const DefaultFormEditButtons = ({
  cancelHandler,
  saveEditingHandler = null,
  extraClassName = '',
  saveButtonText = 'Save',
  saveButtonExtraProps = {},
  hideSaveButton = false,
}) => (
  <div className={[styles.FormEditButtons, extraClassName].join(' ')} data-testid="FormEditButtons">
    <SecondaryButton className={styles.CancelDetail} onClick={cancelHandler}>
      Cancel
    </SecondaryButton>
    {!hideSaveButton && (
      <PrimaryButton
        inline
        className={styles.SaveDetail}
        onClick={saveEditingHandler}
        {...saveButtonExtraProps}
      >
        {saveButtonText}
      </PrimaryButton>
    )}
  </div>
);

DefaultFormEditButtons.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  saveEditingHandler: PropTypes.func,
  saveButtonExtraProps: PropTypes.shape({}),
  extraClassName: PropTypes.string,
  saveButtonText: PropTypes.string,
  hideSaveButton: PropTypes.bool,
};
